import workspace from "../components/canvas/core/workspace";
import sqftShape from "../components/canvas/core/shapes/sqftShape";
import {BACKSPLASH_LABELS, EDGE_LABELS, SQFT_FEATURES} from "../constants";
import workspaceZoom from "../components/canvas/core/workspaceZoom";
import ShapeHelper from "./shapeHelper";
//import sqftConfig from "../components/canvas/store/sqftConfig";
import workspaceControllers from "../components/canvas/store/workspaceControllers";

export const highlightShapes = (shapeIds) => {
  //sqftConfig.setScale(2.5);
  //Zoom to center of all shapes
  const shapesAndAttachedResources = workspace.getShapes().filter(shape => shapeIds.includes(shape.id));

  const centerPoint = getShapesCenterPoint(shapeIds);
  if (centerPoint) {
    window.setTimeout(() => {
      workspaceZoom.zoomTo(centerPoint, 0.1);
    }, 100)
  }

  //sqftConfig.setScale(2.5);
  console.log("getPosition after", workspace.getPosition());

  for (const shape of shapesAndAttachedResources) {
    if (shape instanceof sqftShape) {
      shape.shapeRender.blink.start({ blinkMs: 1400, totalMs: 5000, colorOverride: 'rgba(255,0,0,0.6)' });
    } else if ([...Object.keys(EDGE_LABELS), ...Object.keys(BACKSPLASH_LABELS), SQFT_FEATURES.crown_molding, SQFT_FEATURES.handle, SQFT_FEATURES.hinge].includes(shape.partId)) {
      const line = workspace.getLineById(shape.id);
      if (line) {
        line.blink.start({ blinkMs: 1400, totalMs: 5000, colorOverride: 'rgba(255,0,0,0.6)' });
      }
    }
  }
}

export const getShapesCenterPoint = (shapeIds) => {
  const attachedResources = workspace.getAllAttachedResources();
  const parentShapes = [];
  // parent shapes for attached to line resources
  for (const attached of attachedResources) {
    const sqftShape = workspace.getShapeById(attached.attachedToParentId);
    parentShapes.push(sqftShape);
  }

  // parent shapes for controllers
  Object.values(workspaceControllers).forEach(workspaceController => {
    if (typeof workspaceController?.getResourceById === 'function') {
      for (const shapeId of shapeIds) {
        const resource = workspaceController.getResourceById(shapeId);
        if (resource && resource.shapeId) {
          const sqftShape = workspace.getShapeById(resource.shapeId);
          if (sqftShape) {
            parentShapes.push(sqftShape);
          }
        }
      }
    }
  });

  // regular shapes
  const shapes = workspace.getShapesWithoutAttachedResources().filter(shape => shapeIds.includes(shape.id));
  let centerPoint = getShapesCenter([...shapes, ...parentShapes]);

  return centerPoint;
}

export const getShapesCenter = (shapes) => {
  const shapesCenterPoints = shapes.map(shape => {
    return workspaceZoom.getShapeCenter(shape);
  });

  const center = ShapeHelper.getCenterPoint(shapesCenterPoints);
  return  {x: center.x, y: center.y}
}
